import { internalFetch } from '../utils/fetchHelper';
import { IWorkAssignmentResponse } from './workService';
import { IQrCode } from './qrCodeService';
import { IIssue } from './issueService';
export interface INotifMessage {
  t: string; // type
  l: number; // level
  b: string; // body
}

export interface IAssetDetails {
  asset: IAsset;
  issues: IIssue[];
  qrCode: IQrCode;
}

export interface supportedIssue {
  name: string;
  id: string;
}
export interface IAsset {
  changeDate?: string;
  code: string;
  createdAt?: string;
  id: number;
  parentId?: number;
  parentName?: string;
  name: string;
  uuid: string;
  category: string;
  categoryId: number;
  zoneId?: number;
  zoneName?: string;
  statusId?: number;
  statusName?: string;
  supportedIssues?: supportedIssue[];
  metadataName?: string;
  otherInfo?: string;
  modifiedAt?: string;
  modifiedBy?: number;
}

export interface IActivityLogItem {
  loggedAt: string;
  username: string;
  action: string;
  summary: string;
}

export interface IDateTimeRange {
  startTime: Date;
  endTime: Date;
}
export interface ITimeslot extends IDateTimeRange {
  rentId?: number;
  rentCode?: string;
}
export interface IScheduledStatus extends IDateTimeRange {
  statusId: number;
  statusName: string;
}
export interface IGetAssetAvailabilitiesResponse {
  timeslots: ITimeslot[];
  scheduledStatuses: IScheduledStatus[];
}

export interface IEntityLocation {
  id: number;
  time: string;
  latitude: number;
  longitude: number;
}

export interface IPagedCollection<itemType> {
  isLastPage: boolean;
  items: itemType[];
  pageCount: number;
  pageNo: number;
  pageSize: number;
  rowsCount: number;
}

export interface ICreateAssetRequest {
  uuid: string;
  code: string;
  name: string;
  parentId?: number;
  categoryId?: number;
  zoneId?: number;
  statusId?: number;
  changedate: string;
  metadataName?: string;
  otherInfo?: Record<string, unknown>;
}

export interface IUpdateAssetRequest {
  code: string | undefined;
  name: string | undefined;
  parentId: number | undefined;
  metadataName?: string;
  categoryId?: number;
  zoneId?: number;
  statusId?: number;
  changedate: string | undefined;
  otherInfo?: Record<string, unknown>;
}

export interface ICreateAssetResponse {
  assetId: number;
  qrCodeId: number;
  isSuccess: boolean;
  message?: string;
}
export interface ICreateAssetStatusRequest {
  code?: string;
  name: string;
  color?: string;
  icon?: string;
  lockEntity?: boolean;
  clientLabel?: string;
  managerLabel?: string;
  contractorLabel?: string;
  ClientLabel?: string;
  ManagerLabel?: string;
  ContractorLabel?: string;
  ShowClientDashboardCard?: boolean;
  ShowManagerDashboardCard?: boolean;
}
export interface ICreateAssetStatusResponse {
  assetStatusId: number;
}
export interface IUpdateAssetStatusRequest {
  code?: string;
  name: string;
  color?: string;
  icon?: string;
  lockEntity?: boolean;
  clientLabel?: string;
  managerLabel?: string;
  contractorLabel?: string;
  ClientLabel?: string;
  ManagerLabel?: string;
  ContractorLabel?: string;
  ShowClientDashboardCard?: boolean;
  ShowManagerDashboardCard?: boolean;
}

export interface IScheduleActionRequest {
  time: string;
  actionType: number;
  statusId?: number;
  workflowId?: number;
  description: string;
}

export interface IStatus {
  id: number;
  name: string;
  code: string;
  color: string;
  icon: string;
  lockEntity?: boolean;
  LockEntity?: boolean;
  clientLabel?: string;
  managerLabel?: string;
  contractorLabel?: string;
  ClientLabel?: string;
  ManagerLabel?: string;
  ContractorLabel?: string;
  ShowClientDashboardCard?: boolean;
  ShowManagerDashboardCard?: boolean;
}

export type IAssetStatus = IStatus;

export interface IScheduledAction {
  uuid: string;
  entityType: string;
  scheduledTime: Date;
  actionStatus: string;
  assetId: number;
  assetStatusId: number;
  workId: number;
  workStatusId: number;
  description: string;
  createdDate: Date;
  id: number;
  createdAt: Date;
}

export const getAssets = async (
  abortController: AbortController,
  pageSize: number,
  pageNo: number,
  orderBy?: string,
  search?: string,
  filters?: string
): Promise<IPagedCollection<IAsset>> => {
  return internalFetch(
    `${
      import.meta.env.VITE_BACKEND_API_URL
    }/p/assets?pageSize=${pageSize}&pageNo=${pageNo}${
      orderBy ? `&orderBy=${orderBy}` : ''
    }${search ? `&search=${search}` : ''}${
      filters ? `&filters=${filters}` : ''
    }&code=${import.meta.env.VITE_BACKEND_API_KEY}`,
    'GET',
    abortController
  );
};

export const getAssetAvailabilities = async (
  abortController: AbortController,
  assetId: number,
  durationDays?: number,
  durationHalfADays?: number,
  durationHours?: number,
  durationHalfAnHour?: number,
  before?: string,
  after?: string
): Promise<IGetAssetAvailabilitiesResponse> => {
  return internalFetch(
    `${
      import.meta.env.VITE_BACKEND_API_URL
    }/p/assetAvailabilities?assetId=${assetId}${
      durationDays ? `&durationDays=${durationDays}` : ''
    }${durationHalfADays ? `&durationHalfADays=${durationHalfADays}` : ''}${
      durationHours ? `&durationHours=${durationHours}` : ''
    }${durationHalfAnHour ? `&durationHalfAnHour=${durationHalfAnHour}` : ''}${
      before ? `&before=${before}` : ''
    }${after ? `&after=${after}` : ''}&code=${
      import.meta.env.VITE_BACKEND_API_KEY
    }`,
    'GET',
    abortController
  );
};

export const getAssetAudits = async (
  abortController: AbortController,
  assetId: number,
  pageSize: number,
  pageNo: number
): Promise<IPagedCollection<IAsset>> => {
  return internalFetch(
    `${
      import.meta.env.VITE_BACKEND_API_URL
    }/p/assetAudit?assetId=${assetId}&pageSize=${pageSize}&pageNo=${pageNo}&code=${
      import.meta.env.VITE_BACKEND_API_KEY
    }`,
    'GET',
    abortController
  );
};

export const getLabelsets = async (
  abortController: AbortController
): Promise<any> => {
  return internalFetch(
    `${import.meta.env.VITE_BACKEND_API_URL}/p/labelsets?code=${
      import.meta.env.VITE_BACKEND_API_KEY
    }`,
    'GET',
    abortController
  );
};

export const getAssetParents = async (
  abortController: AbortController,
  assetId: number
): Promise<IAsset[]> => {
  return internalFetch(
    `${
      import.meta.env.VITE_BACKEND_API_URL
    }/p/assetParents?assetId=${assetId}&code=${
      import.meta.env.VITE_BACKEND_API_KEY
    }`,
    'GET',
    abortController
  );
};

export const getAssetQR = async (
  abortController: AbortController,
  assetId?: number,
  assetCode?: string
): Promise<IQrCode> => {
  return internalFetch(
    `${import.meta.env.VITE_BACKEND_API_URL}/p/assetQR?${
      assetId ? `assetId=${assetId}` : `assetCode=${assetCode}`
    }&code=${import.meta.env.VITE_BACKEND_API_KEY}`,
    'GET',
    abortController
  );
};

export const getAsset = async (
  abortController: AbortController,
  assetId?: number,
  assetCode?: string
): Promise<IAsset> => {
  return internalFetch(
    `${import.meta.env.VITE_BACKEND_API_URL}/p/asset?${
      assetId ? `assetId=${assetId}` : `assetCode=${assetCode}`
    }&code=${import.meta.env.VITE_BACKEND_API_KEY}`,
    'GET',
    abortController
  );
};

export const editAsset = async (
  abortController: AbortController,
  assetId: number,
  asset: IUpdateAssetRequest
): Promise<number> => {
  return internalFetch(
    `${
      import.meta.env.VITE_BACKEND_API_URL
    }/p/assetById?assetId=${assetId}&code=${
      import.meta.env.VITE_BACKEND_API_KEY
    }`,
    'PUT',
    abortController,
    JSON.stringify(asset)
  );
};

export const deleteAsset = async (
  abortController: AbortController,
  assetId: number
): Promise<number> => {
  return internalFetch(
    `${
      import.meta.env.VITE_BACKEND_API_URL
    }/p/assetById?assetId=${assetId}&code=${
      import.meta.env.VITE_BACKEND_API_KEY
    }`,
    'DELETE',
    abortController
  );
};

export const createAsset = async (
  abortController: AbortController,
  data: ICreateAssetRequest
): Promise<ICreateAssetResponse> => {
  return internalFetch(
    `${import.meta.env.VITE_BACKEND_API_URL}/p/asset`,
    'POST',
    abortController,
    JSON.stringify(data)
  );
};
export const getAssetStatuses = async (
  abortController: AbortController
): Promise<IAssetStatus[]> => {
  return internalFetch(
    `${import.meta.env.VITE_BACKEND_API_URL}/p/assetsStatuses`,
    'GET',
    abortController
  );
};

export const createAssetStatus = async (
  abortController: AbortController,
  assetStatus: ICreateAssetStatusRequest
): Promise<ICreateAssetStatusResponse> => {
  return internalFetch(
    `${import.meta.env.VITE_BACKEND_API_URL}/p/assetStatus`,
    'POST',
    abortController,
    JSON.stringify(assetStatus)
  );
};

export const updateAssetStatus = async (
  abortController: AbortController,
  assetStatusId: number,
  assetStatus: IUpdateAssetStatusRequest
): Promise<number> => {
  return internalFetch(
    `${
      import.meta.env.VITE_BACKEND_API_URL
    }/p/assetStatusById?assetStatusId=${assetStatusId}`,
    'PUT',
    abortController,
    JSON.stringify(assetStatus)
  );
};

export const getScheduledUpdateAssetStatus = async (
  abortController: AbortController,
  assetId?: number,
  assetCode?: string
): Promise<IScheduledAction[]> => {
  return internalFetch(
    `${import.meta.env.VITE_BACKEND_API_URL}/p/scheduledUpdateAssetStatus?${
      assetId ? `assetId=${assetId}` : `assetCode=${assetCode}`
    }&code=${import.meta.env.VITE_BACKEND_API_KEY}`,
    'GET',
    abortController
  );
};

export const scheduleUpdateAssetStatus = async (
  abortController: AbortController,
  data: IScheduleActionRequest,
  assetId?: number,
  assetCode?: string
): Promise<IWorkAssignmentResponse> => {
  return internalFetch(
    `${import.meta.env.VITE_BACKEND_API_URL}/p/scheduleUpdateAssetStatus?${
      assetId ? `assetId=${assetId}` : `assetCode=${assetCode}`
    }`,
    'POST',
    abortController,
    JSON.stringify(data)
  );
};

export const cancelScheduledUpdateAssetStatus = async (
  abortController: AbortController,
  scheduleActionId: number
): Promise<string> => {
  return internalFetch(
    `${
      import.meta.env.VITE_BACKEND_API_URL
    }/p/scheduleUpdateAssetStatus?scheduleActionId=${scheduleActionId}`,
    'DELETE',
    abortController
  );
};
